import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { partial } from '../../../../util/translation/translation';
import Api from '../../../../util/api';
import { useQuery } from '@tanstack/react-query';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import Loading from '../../../shared/Spinner';

const Event = ({ event }) => {
  const dT = partial('DashboardPage');
  const eP = partial('EventParticipantsPage');
  const [filledSpots, setFilledSpots] = useState(0);
  const [filledWidth, setFilledWidth] = useState('');

  const { data: declinedEvents = [], isLoading } = useQuery({
    queryKey: ['participant-invites', event.id],
    queryFn: () => Api.events.getDeletedParticipants(event.id),
  });

  useEffect(() => {
    const { maxAttendees, participants } = event;
    const filled = participants.reduce(
      (total, participant) => total + participant.friendAmount + 1,
      0
    );
    const filledPercentage = (filled * 100) / maxAttendees;
    setFilledSpots(filled);
    setFilledWidth(filledPercentage);
  }, []);

  return (
    <Link
      to={`/events/edit/${event.id}`}
      className="flex flex-row flex-start hover-link"
    >
      <div className="dashboard-event-calendar">
        <div className="dashboard-event-calendar-month">
          {moment(event.startDate).format('MMM')}
        </div>
        <div className="dashboard-event-calendar-day">
          {moment(event.startDate).format('DD')}
        </div>
      </div>
      <div className="flex flex-column flex-1">
        <div className="dashboard-event">
          <div className="dashboard-event-wrapper">
            <div className="dashboard-event-content">
              <h3 className="dashboard-event-content-title">{event.title}</h3>
              <div className="dashboard-event-content-date">
                {dT('salesStart')}:{' '}
                {moment(event.registrationStart).format('DD')}.
                {moment(event.registrationStart).format('MMM')},{' '}
                {moment(event.registrationStart).format('HH')}:
                {moment(event.registrationStart).format('mm')}
              </div>
            </div>
          </div>
          <div>
            <div className="dashboard-event-participants">
              <span className="dashboard-event-participants-count">
                {filledSpots}
              </span>{' '}
              /{' '}
              <span className="dashboard-event-participants-max">
                {event.maxAttendees}
              </span>
            </div>
            <div className="dashboard-event-participants">
              {isLoading ? (
                <Loading />
              ) : (
                <Tooltip
                  placement="bottom"
                  overlay={eP('deletedParticipant')}
                  overlayClassName="dashboard-tooltip"
                >
                  <span className="dashboard-event-participants-count text-danger">
                    {declinedEvents.data?.length > 0
                      ? '-' + declinedEvents.data?.length
                      : 0}
                  </span>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
        <div className="dashboard-event-progress">
          <div
            className="dashboard-event-progress-bar"
            style={{ width: `${filledWidth}%` }}
          />
          <div className="dashboard-event-progress-indicator" />
        </div>
      </div>
    </Link>
  );
};
export default Event;
